module.exports = __webpack_public_path__ + "img/ElectricAlarm.214ae116.svg";